<script>
import { BCardImg } from "bootstrap-vue";

export default {
  extends: BCardImg
};
</script>